module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/readable-stream/transform.js
// module id = 571
// module chunks = 0 3 5